<template>
    <span>
        <div v-for="(data, key) of value">
            <div class="col-sm-1">
                <label :for="id + key">{{ (key + 1)}} &nbsp;</label>
            </div>
            <div class="col-sm-8">
                <input :id="id + key" type="text" v-model="value[key]" :tabIndex="1 + key" style="width:100%" v-on:input.prevent.stop="checkNewLine" v-on:keydown.enter.prevent="switchNewLine" :data-key="key">
            </div>
            <div class="col-sm-3">
                <button type="button" class="btn btn-danger" v-on:click.prevent="deleteRow(key)">刪除</button>
            </div>
        </div>
        <slot></slot>
    </span>
</template>

<script>
  export default {
    computed: {
      valueString: function () {
        return JSON.stringify(this.value.filter(function (item) { return item.trim() }));
      }
    },
    data() {
      const id = 'array' + Math.floor(Math.random() * 100)
      return {
        'value': [],
        'id': id,
        'inputDOM': null,
      };
    },
    mounted() {
      let inputDOM = this.$el.querySelector('input');
      this.inputDOM = inputDOM;
      this.value = JSON.parse(inputDOM.value);
    },
    methods: {
      deleteRow: function (rowId) {
        this.value.splice(rowId, 1);
      },
      checkNewLine: function ($event) {
        if ($event.inputType === 'insertFromPaste') {
          let newString = $event.target.value.replace($event.target._value, '')
          let newWord = newString.split(' ');
          let key = $event.target.dataset.key;
          this.value.splice(key + 1, 0, ...newWord.slice(1));
          this.value[key] = $event.target._value + newWord[0];
        }
      },
      switchNewLine: function ($event) {
        switch($event.key) {
          case 'Enter':
            let target = $event.target;
            let tabIndex = target.tabIndex;
            this.$el.querySelector('[tabIndex="' + (tabIndex + 1) + '"]').focus();
            break;
        }
      }
    },
    watch: {
      value: function (value) {
        let length = value.length;

        if (value[length - 1] !== '') {
          value.push('');
        }

        this.inputDOM.value = this.valueString;
      },
    }
  }
</script>
